import {
  SHOPIFY_AG1_POUCH_DOUBLE_SUB_VARIANT_ID_V53,
  SHOPIFY_AG1_POUCH_OTP_VARIANT_ID_V53,
  SHOPIFY_AG1_POUCH_SINGLE_SUB_VARIANT_ID_V53,
  SHOPIFY_TRAVEL_PACK_DOUBLE_SUB_VARIANT_ID_V53,
  SHOPIFY_TRAVEL_PACK_OTP_VARIANT_ID_V53,
  SHOPIFY_TRAVEL_PACK_SINGLE_SUB_VARIANT_ID_V53,
  VariantIdObject
} from '@portal/config/base';
import { StoreCode } from '@portal/schema/storeCode';

const getValues = (obj: VariantIdObject) => Object.values(obj).filter(Boolean) as string[];

export const isPouchOrTravelPackV53Variant = (id: string, store: StoreCode): boolean => {
  if (!id) return false;

  const v53PouchVariants = [
    ...getValues(SHOPIFY_AG1_POUCH_OTP_VARIANT_ID_V53[store]),
    ...getValues(SHOPIFY_AG1_POUCH_SINGLE_SUB_VARIANT_ID_V53[store]),
    ...getValues(SHOPIFY_AG1_POUCH_DOUBLE_SUB_VARIANT_ID_V53[store])
  ];

  const v53TravelPackVariants = [
    ...getValues(SHOPIFY_TRAVEL_PACK_OTP_VARIANT_ID_V53[store]),
    ...getValues(SHOPIFY_TRAVEL_PACK_SINGLE_SUB_VARIANT_ID_V53[store]),
    ...getValues(SHOPIFY_TRAVEL_PACK_DOUBLE_SUB_VARIANT_ID_V53[store])
  ];

  const allV53Variants = [...v53PouchVariants, ...v53TravelPackVariants];

  return allV53Variants.includes(id);
};
